import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { PopularCompetencyPayload } from '../PopularCompetencies/Decoder';

interface Props {
  popularCompetencies: NonEmptyList<PopularCompetencyPayload>;
}

function Row({ popularCompetencies }: Props) {
  return popularCompetencies.toArray().map((popularCompetency, index) => (
    <div key={index} className="flex justify-between mt-4 h-6 items-center">
      <Typography variant="bodyMedium" color="dark">
        {popularCompetency.name}
      </Typography>
      <Typography variant="bodyMedium" fontWeight="bold" color="dark">
        {popularCompetency.enrollments}
      </Typography>
    </div>
  ));
}

export default observer(Row);
